import React from 'react';
import LinkCorporationInvite from './LinkCorporationInvite';
import MaxGeneralId from './MaxGeneralId';
import './LinkCorporationInvite.css';
import Constant from '@/common/constant/Constant';

export default function FieldInvitedPartnerB2b({
    setValue,
    getValues,
    clearErrors,
    errorlist,
    setErrorCreateTicket,
    register,
    defaultMaxGeneralId,
    defaultSubdomainInvited,
    disabled,
    ticketType,
    setIsEdited,
    numberGeneralIdLeft
}) {
    return (
        <div>
            {ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT && (
                <MaxGeneralId
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    errorlist={errorlist}
                    setErrorCreateTicket={setErrorCreateTicket}
                    defaultMaxGeneralId={defaultMaxGeneralId}
                    disabled={disabled}
                    numberGeneralIdLeft={numberGeneralIdLeft}
                />
            )}
            <LinkCorporationInvite
                setValue={setValue}
                getValues={getValues}
                clearErrors={clearErrors}
                errorlist={errorlist}
                setErrorCreateTicket={setErrorCreateTicket}
                defaultSubdomainInvited={defaultSubdomainInvited}
                disabled={disabled}
                ticketType={ticketType}
                setIsEdited={setIsEdited}
                register={register}
            />
        </div>
    );
}
